import {i18n} from '@yourcoach/i18n';

import type {EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (): EventData => {
  const title = i18n.t('shared:update_your_schedule');

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',
    icon: AlarmIcon,
    iconGradient: 'danger',
    title,
  };
};
